import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { DynamicObjectType } from 'types/commons';
import { formatDateTime } from 'utils/formattedString';

const DATA_TIME = {
  REJECTED: 'rejectedTime',
  CONFIRMED_PICK: 'confirmedTime',
  COMPLETED: 'completedTime',
};

const OrderSummary = ({ data }: { data: DynamicObjectType }) => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const summaries = useMemo(() => {
    return [
      // {
      //   text: 'transferOrders.transferOrderId',
      //   value: data?.transferNumber || data?.id,
      // },
      // data?.status !== 'AWAITING_CONFIRMATION'
      //   ? {
      //       text: 'TO Number',
      //       value: data?.transferNumber || data?.id,
      //     }
      //   : {},
      // {
      //   text: 'TO Number',
      //   value: data?.transferNumber || '_',
      // },
      {
        text: 'transferOrders.relatedOrderId',
        value: data?.order?.orderNumber,
        isLink: true,
      },
      data?.status === 'CANCELLED'
        ? {
            text: 'transferOrders.cancelledTime',
            value: data?.cancelledTime
              ? formatDateTime(data?.cancelledTime)
              : '',
          }
        : {},
      {
        text: t(`transferOrders.createdTime`),
        value: formatDateTime(data?.createdAt),
      },
      Object.keys(DATA_TIME)?.includes(data?.status)
        ? {
            text: t(`transferOrders.${DATA_TIME?.[data?.status]}`),
            value: formatDateTime(
              data?.[DATA_TIME?.[data?.status]] || data?.createdAt,
            ),
          }
        : {},
      {
        text: 'transferOrders.createdBy',
        value: data?.creator
          ? `${data?.creator?.firstName || ''} ${data?.creator?.lastName || ''}`
          : 'System',
      },
    ];
  }, [data]);

  const redirectToOrder = useCallback(() => {
    if (data?.order?.id) {
      const orderType = data?.order?.orderType;
      if (orderType === 'TAB_TRY_BUY') {
        navigate(`/orders-keep-and-try/${data?.order?.id}/show`);
      } else {
        navigate(`/order-management/${data?.order?.id}/show`);
      }
    }
  }, [data?.order?.id, navigate]);

  return (
    <div className="w-full summary-container mt-[20px]">
      <div className="summary-container__data">
        <div
          className={`grid ${data?.status === 'CANCELLED' ? 'grid-cols-5' : 'grid-cols-4'} gap-4`}
        >
          {summaries
            ?.filter((i) => i?.text)
            ?.map((e: DynamicObjectType) => (
              <div className="flex justify-start items-center" key={e?.value}>
                <div>
                  <div className="mb-[5px] text-highlight opacity-50">
                    {t(e.text)}
                  </div>
                  <div
                    className={`text-[14px] fw-600 text-highlight ${e?.isLink ? 'cursor-pointer hover:bg-[#0000000f]' : ''}`}
                    style={{
                      color: e?.color,
                    }}
                    onClick={() => {
                      e?.isLink && redirectToOrder();
                    }}
                  >
                    {e?.value || '-'}
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default OrderSummary;
